export const services = [
  {
    title: '客服专员',
    desc: '1对1专属客服，24小时极速响应，多渠道便捷沟通，团队从业经验均为5年以上',
    image: '/images/gp-service.png',
  },
  {
    title: '财务结算',
    desc: '严谨的专业态度，合规的处理流程，为您提供高效准确的财务结算',
    image: '/images/gp-finance.png',
  },
  {
    title: '市场销售',
    desc: '深入了解市场政策，实时跟踪行业动态，根据不同客户需求促成合作方案',
    image: '/images/gp-sales.png',
  },
  {
    title: '技术支持',
    desc: '高水准技术支持，专注技术服务，提供免费的系统对接，实现审批-预订-报销全流程化',
    image: '/images/gp-support.png',
  },
]
